import { projectsDataStore } from "Stores";
import { ListStore } from "Stores/RESTStore/ListStore";
import { groupGUIStore } from "./GroupsStore";

export interface TransmittedMember {
  id: number;
}

class GroupGroupsMembersListStore extends ListStore<API_Group> {
  url(): string {
    // Fixme: Temp URL
    return `api/projects/${projectsDataStore.projectId}/groups/${groupGUIStore.currentGroupId}/unassignedGroups`;
  }

  getMember(member: TransmittedMember) {
    return this.list.find((val) => val.id === member.id);
  }

  getMemberById(groupId: number) {
    return this.list.find((val) => val.id === groupId);
  }
}

export const groupGroupsMembersListStore = new GroupGroupsMembersListStore();
